/**
 * Tag replacer approach doesn't work because app.js bundle is reading acConfig before fetching ac-config.json.
 * This is because MFE library needs setting up public path on webpack. Standalone app may rely on auto
 * public path similar to FE-container and resolve the issue, but this setting is shared between MFE and
 * Standalone app and automatic public path generation doesn't work for MFE.
 * More info about __webpack_public_path__ at : https://webpack.js.org/guides/public-path/#on-the-fly
 */

// only importing types is allowed, should not load any code before initializing "__webpack_public_path__"
import { Config } from '@ac/library-utils/dist/declarations/config';

// @typescript-eslint/ban-ts-comment
// @ts-expect-error webpack hidden thing, https://webpack.js.org/guides/public-path/#on-the-fly
// eslint-disable-next-line camelcase
__webpack_public_path__ = {
  // toString trick to move execution of this from build time to runtime.
  toString: (): string =>
    (window.acConfig as Config).frontendUrls.translations + '/',
};

export {};
